// extracted by mini-css-extract-plugin
module.exports = {"spinSize":"Dashboard_spinSize__1nEzd","customDropdown":"Dashboard_customDropdown__1JpC2","customInput":"Dashboard_customInput__7RdeZ"};